import React from 'react';
import { features } from './data';
import './Styles/Features.scss';
import Card from '../../Shared/Cards/FeatureCard/Card';
const Features=()=>{
    return(
        <div className="wireframe-features">
            {features.map((d) =>{
                return(
                    <Card 
                    {...d}
                    />
                )
            })}
        </div>
    )
};
export default Features ;